export default "__VITE_ASSET__07e33ab2__"